import { render, staticRenderFns } from "./SeibiDetail.vue?vue&type=template&id=123cd3df&scoped=true&"
import script from "./SeibiDetail.vue?vue&type=script&lang=ts&"
export * from "./SeibiDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SeibiDetail.vue?vue&type=style&index=0&id=123cd3df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123cd3df",
  null
  
)

component.options.__file = "SeibiDetail.vue"
export default component.exports